import { render, staticRenderFns } from "./EsperaUrgencias.vue?vue&type=template&id=14a40300&"
import script from "./EsperaUrgencias.vue?vue&type=script&lang=js&"
export * from "./EsperaUrgencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports